const gameEmojis = new Map([
  ['Mario', '👨🏻🍄🐢'],
  ['Zelda', '🧝‍♂️🗡️🛡️'],
  ['Metroid', '👩‍🚀🚀👾'],
  ['Donkey Kong', '🦍🍌🔨'],
  ['Pokemon', '🔴🐱🔥'],
  ['Smash', '🥊🍄🔨'],
  ['Animal Crossing', '🏠🌳🦊'],
  ['Kirby', '💗👅🍰'],
  ['Mario Kart', '🏎️🍄🏆'],
  ['Splatoon', '🦑🔫🎨'],
  ['Fire Emblem', '🗡️🏰🔥'],
  ['Star Fox', '🦊🚀👾'],
  ['Pikmin', '🍃🍎🚀'],
  ['Mario Party', '🍄🎉🎲'],
  ['Sonic', '🦔💨💍'],
  ['Street Fighter', '🥋🥊🌍'],
  ['Mega Man', '🔵🤖🔫'],
  ['Final Fantasy', '⚔️🧚🐉'],
  ['Age of Empires', '🏰⚔️🌍'],
  ['Call of Duty', '🔫💣💥'],
]);

export default gameEmojis;
